import {
  RECOVER_ACCOUNT,
  SELECT_RECOVERY_ACCOUNT,
  SET_RESET_CODE,
  CHOOSE_RECOVERY_METHOD,
} from "../actions/accountRecovery.actions";

const defaultState = {
  errors: {},
  recoveryMethod: null,
  verificationCode: null,
  selectedAccount: null,
  matchedAccounts: []
};

const authReducer = (state = defaultState, action) => {
  switch (action.type) {
    case `${RECOVER_ACCOUNT}_SUCCEEDED`:
      const { profiles } = action.payload.data;

      return {
        ...state,
        matchedAccounts: profiles,
        errors: defaultState.errors
      };

    case `${RECOVER_ACCOUNT}_PENDING`:
      return state;

    case `${RECOVER_ACCOUNT}_FAILED`:
      return {
        ...defaultState,
        errors: { error: [action.payload.response.data.msg] }
      };

    case `${SELECT_RECOVERY_ACCOUNT}_SUCCEEDED`:
      const profile = action.payload.profile || action.payload;
      return {
        ...state,
        selectedAccount: { ...profile },
      };

    case CHOOSE_RECOVERY_METHOD:
      return {
        ...state,
        recoveryMethod: action.payload.recoveryMethod,
      };

    case SET_RESET_CODE:
      return {
        ...state,
        verificationCode: action.payload,
      };

    default:
      return state;
  }
};

export default authReducer;



// WEBPACK FOOTER //
// ./src/redux/reducers/accountRecovery.reducer.js